// src/components/Layout.jsx
import React, { useEffect, useState } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";

/**
 * Layout component wraps the whole app:
 * - shows Sidebar and Header
 * - handles Escape key to step back (navigate -1)
 * - provides top-left Back button (calls navigate(-1))
 */
export default function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  const handleBack = () => {
    // try to go back; if at root/dashboard, go to dashboard explicitly
    try {
      navigate(-1);
    } catch (e) {
      navigate("/dashboard");
    }
  };

  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === "Escape") {
        // avoid navigating while user is typing in an input/textarea/contenteditable
        const active = document.activeElement;
        const isTyping =
          active &&
          (active.tagName === "INPUT" ||
            active.tagName === "TEXTAREA" ||
            active.getAttribute("contentEditable") === "true");
        if (isTyping) return;

        // if already at dashboard/root, do nothing
        if (location.pathname === "/" || location.pathname === "/dashboard") {
          return;
        }
        navigate(-1);
      }
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [navigate, location]);

  return (
    <div className="flex h-screen">
      <Sidebar isOpen={sidebarOpen} />

      <div className="flex-1 flex flex-col">
        <Header
          onToggleSidebar={() => setSidebarOpen((s) => !s)}
          onBack={handleBack}
        />

        <main className="p-4 overflow-auto bg-gray-50">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
